/**
 * 사유서 시각 표시.
 *
 * 외출 사유서는 expected_arrival_time / expected_departure_time 중 어느 쪽이
 * 나간 시각인지 컬럼 이름으로 알 수 없다(제출 폼마다 반대로 담는다).
 * 그래서 값을 정렬해 이른 쪽을 '외출', 늦은 쪽을 '복귀'로 본다.
 */
export function formatExceptionTime(
  exceptionType?: string | null,
  arrivalTime?: string | null,
  departureTime?: string | null
): string | null {
  const times = [departureTime, arrivalTime]
    .filter((t): t is string => !!t)
    .map((t) => t.slice(0, 5))
    .sort();
  if (times.length === 0) return null;

  if (exceptionType?.includes('외출')) {
    return times.length === 2 ? `외출 ${times[0]} → 복귀 ${times[1]}` : times[0];
  }
  if (exceptionType?.includes('지각')) return `도착 예정 ${times[0]}`;
  if (exceptionType?.includes('조퇴')) return `퇴실 예정 ${times[0]}`;

  const parts: string[] = [];
  if (arrivalTime) parts.push(`도착 예정 ${arrivalTime.slice(0, 5)}`);
  if (departureTime) parts.push(`퇴실 예정 ${departureTime.slice(0, 5)}`);
  return parts.join(' ');
}
